import * as Sentry from "@sentry/angular-ivy";
import {APP_INITIALIZER, ErrorHandler} from "@angular/core";
import {Router} from "@angular/router";
import {environment} from "./environments/environment";
import {SENTRY_DSN} from "@gebeya/g-saas-core-mf-shared-ts";

export const INIT_SENTRY = (TAG: string) => {
  // initialize Sentry only for Production environment
  if (environment.production && environment.name) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: environment.name,
      integrations: [
        new Sentry.BrowserTracing({
          routingInstrumentation: Sentry.routingInstrumentation,
        }),
        new Sentry.Replay(),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
    Sentry.setTag("APPLICATION_NAME", TAG); // used to identify which micro-frontend is the error source
  }
};

export const SENTRY_PROVIDERS = () => {
  // if environment is not production, no sentry providers
  if (!environment.production) {
    return [];
  }
  return [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
  ]
};
